// Pinterest pin sirasi API istemcisi.
// Pinterest API'si Standard erisim onayi istedigi icin pinler eklentiyle atilir:
// eklenti Pinterest'in pin olusturma formunu doldurur, Yayinla'ya kullanici basar.

import { authHeaders, getBackendUrl } from "./http";
import { callExtension } from "./extension";

export interface PinterestConfig {
  autoQueue: boolean;
  /** Pano urun kategorisinden otomatik (Necklaces, T-Shirts...) */
  autoBoard: boolean;
  /** kategori anahtari -> pano adi (bos = otomatik ad) */
  categoryBoards: Record<string, string>;
  /** dikey -> pano adi (autoBoard kapaliyken) */
  boards: Record<string, string>;
  defaultBoard: string;
}

export interface PinterestCategory {
  key: string;
  vertical: string;
  label: string;
  /** otomatik pano adi */
  board: string;
}

export type PinStatus = "queued" | "pinned" | "skipped";

export interface PinterestPin {
  id: string;
  listingDraftId: string | null;
  etsyListingId: string;
  vertical: string | null;
  status: PinStatus;
  title: string;
  description: string;
  altText: string | null;
  imageUrl: string;
  link: string;
  board: string | null;
  resolvedBoard: string;
  pinUrl: string | null;
  note: string | null;
  pinnedAt: string | null;
  createdAt: string;
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${getBackendUrl()}/api/pinterest${path}`, { ...init, headers: authHeaders() });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.error || "İstek başarısız");
  return json as T;
}

export const getPinterestConfig = () =>
  call<{ data: PinterestConfig; categories: PinterestCategory[] }>("/config").then((r) => ({ ...r.data, categories: r.categories }));

export const savePinterestConfig = (cfg: PinterestConfig) =>
  call<{ data: PinterestConfig }>("/config", { method: "PUT", body: JSON.stringify(cfg) }).then((r) => r.data);

export type PinterestConfigWithCategories = PinterestConfig & { categories: PinterestCategory[] };

export const listPinterestPins = (status: PinStatus | "all") =>
  call<{ data: PinterestPin[]; counts: Record<PinStatus, number> }>(`/pins?status=${status}`);

export const updatePinterestPin = (id: string, patch: Partial<Pick<PinterestPin, "status" | "pinUrl" | "board" | "title" | "description" | "note">>) =>
  call<{ data: PinterestPin }>(`/pins/${id}`, { method: "PATCH", body: JSON.stringify(patch) }).then((r) => r.data);

export const regeneratePinterestPin = (id: string) =>
  call<{ data: PinterestPin }>(`/pins/${id}/regenerate`, { method: "POST" }).then((r) => r.data);

export const backfillPinterestPins = (limit: number) =>
  call<{ data: { added: number } }>("/backfill", { method: "POST", body: JSON.stringify({ limit }) }).then((r) => r.data.added);

export interface PinterestFillResult {
  ok: boolean;
  filled: string[];
  missing: string[];
  error?: string;
  pinId?: string;
}

/** Eklenti Pinterest sekmesini acip formu doldurur. Eklenti yoksa null. */
export const fillPinViaExtension = (pinId?: string) =>
  callExtension<PinterestFillResult>({ type: "PINTEREST_FILL_PIN", payload: pinId ? { pinId } : {} });

/** Liste gorseli /api/files gibi goreli yol olabilir */
export const pinImageSrc = (url: string) => (url.startsWith("/") ? `${getBackendUrl()}${url}` : url);
